module.exports = __webpack_public_path__ + "gi.svg?a5f17d1abdd0f96e9b82206e2ae3d0f9";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/gi.svg
// module id = 1009
// module chunks = 27